import { CommonModule } from '@angular/common';
import {
	AfterViewInit,
	Component,
	inject,
	OnDestroy,
	ViewChild,
} from '@angular/core';
import { PRIMENG_MODULES } from '@shared/primeng';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FireworksComponent } from '../fireworks/fireworks.component';

@Component({
	selector: 'app-global-score',
	imports: [CommonModule, ...PRIMENG_MODULES, FireworksComponent],
	templateUrl: './global-score.component.html',
	styleUrl: './global-score.component.scss',
})
export class GlobalScoreComponent implements AfterViewInit, OnDestroy {
	// add viewchild to #fw reference in HTML
	@ViewChild('fw') fireworks!: FireworksComponent;

	private readonly dynamicDialogConfig = inject(DynamicDialogConfig);

	public oldScore!: number;
	public newScore!: number;
	public profilePic!: string;
	public name!: string;

	constructor() {
		const { oldScore, newScore, profilePic, name } =
			this.dynamicDialogConfig.data || {};

		this.oldScore = oldScore ?? 0;
		this.newScore = newScore ?? 0;
		this.profilePic = profilePic ?? '/assets/images/tcb-logo.png';

		this.name = name ?? '';
	}

	ngAfterViewInit(): void {
		setTimeout(() => this.fireworks.launch(), 500);
	}

	ngOnDestroy(): void {
		this.fireworks.ngOnDestroy();
	}
}
